<template>
  <div class="v-view swiper-view a-fadeIn" :style="{ height: span * 33.33 + '%' }">
    <div class="v-title">{{ title }}</div>

    <swiper v-if="swiperList.length > 0" ref="orderSwiper" class="sv-swiper" :options="swiperOption">
      <swiper-slide class="sv-swiper-slide" v-for="(item, index) in swiperList" :key="item.id" :data-index="index">
        <div class="sv-swiper-slide__avatar">
          <img :src="item.icon" alt="#" />
          <div :class="{ 'a-rolling': item.rolling }">{{ item.type }}</div>
        </div>
        <div class="sv-swiper-slide__info">
          <div class="sv-swiper-slide__wrap">
            <div class="sv-swiper-slide__time">
              <img src="../assets/images/icon_time.png" alt="#" />
              <span>{{ item.time }}</span>
            </div>
            <div class="sv-swiper-slide__address">
              <img src="../assets/images/icon_address.png" alt="#" />
              <span>{{ item.address | textFmt }}</span>
            </div>
          </div>
          <div class="sv-swiper-slide__wrap sv-swiper-slide__desc">
            <img src="../assets/images/icon_content.png" alt="#" />
            <span>{{ item.content }}</span>
          </div>
        </div>
        <img class="sv-swiper-slide__done animated" src="../assets/images/icon_done.png" alt="#" />
      </swiper-slide>
    </swiper>
    <div v-else class="sv-nodata">暂无数据!</div>

    <el-dialog
      top="25vh"
      title="工单信息"
      custom-class="v-dialog"
      :visible.sync="dialogVisible"
      append-to-body
      @opened="onDialogOpened"
    >
      <div class="sv-wrapper">
        <div class="sv-order">
          <div class="sv-order-info">
            <div><label>服务项目：</label>{{ orderData.type }}</div>
            <div><label>服务时间：</label>{{ orderData.time }}</div>
            <div><label>服务人员：</label>{{ orderData.staffName }}</div>
            <div><label>服务电话：</label>{{ orderData.staffPhone }}</div>
            <div><label>长者姓名：</label>{{ orderData.elderName }}</div>
            <div><label>长者电话：</label>{{ orderData.elderPhone }}</div>
            <div><label>开始时间：</label>{{ orderData.timeStart }}</div>
            <div><label>结束时间：</label>{{ orderData.timeEnd }}</div>
            <div><label>开始地址：</label>{{ orderData.addrStart |textFmt}}</div>
            <div><label>结束地址：</label>{{ orderData.addrEnd |textFmt}}</div>
            <!-- <div><label>服务地址：</label>{{ orderData.address }}</div> -->
          </div>
          <swiper v-if="orderData.photos" ref="photoSwiper" class="sv-order-swiper" :options="orderOption">
            <swiper-slide v-for="(item, index) in orderData.photos" :key="index">
              <img :src="item" alt="#" />
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { animateWithDelay } from '@/utils'

export default {
  name: 'ServiceDynamic',
  filters: {
    textFmt(text) {
      if (!text) return
      const index1 = text.indexOf('市')
      const index2 = text.indexOf('自治区')
      if (index1 !== -1) {
        return text.substr(index1 + 1)
      } else if (index2 !== -1) {
        return text.substr(index2 + 3)
      } else {
        return text
      }
    },
  },
  computed: {
    ...mapGetters(['cid']),
  },
  props: {
    span: {
      type: Number,
      default: 1,
    },
    title: {
      type: String,
      default: '居家服务动态',
    },
  },
  watch: {
    swiperData(newData, oldData) {
      const newItem = newData.length && newData[0]
      const oldItem = oldData.length && oldData[0]
      if (!oldItem || newItem.ID !== oldItem.ID) {
        this.swiperList = newData.map((item) => {
          const icon = item.ServiceItemImg
            ? `${process.env.VUE_APP_BASE_URL}${item.ServiceItemImg}`
            : require('@ast/images/img_service.png')
          const content =
            '服务人员' + item.ServiceEmployeeName + '结束对' + item.PersonName + '老人的' + item.ItemName + '服务'
          return {
            id: item.ID,
            icon: icon,
            content: content,
            type: item.ItemName,
            time: item.EndServiceTime,
            address: item.EndPosition || '-',
            rolling: item.ItemName.length > 5,
          }
        })
        this.$nextTick(() => {
          if (!this.orderSwiper) {
            this.orderSwiper = this.$refs.orderSwiper && this.$refs.orderSwiper.swiper
          }
          this.orderSwiper && this.orderSwiper.slideToLoop(0, 0, false)
        })
      }
    },
  },
  data() {
    const vm = this
    return {
      dialogVisible: false,
      dataInterval: null,
      orderData: {},
      orderSwiper: null,
      photoSwiper: null,
      swiperData: [],
      swiperList: [],
      swiperOption: {
        direction: 'vertical',
        grabCursor: true,
        slidesPerView: 4,
        speed: 1000,
        loop: true,
        observer: true,
        observeParents: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        on: {
          click(e) {
            const index = +this.clickedSlide.dataset.index
            const orderID = vm.swiperList[index].id
            vm.getServiceOrderData(orderID)
          },
          autoplay() {
            const slider = this.slides[this.activeIndex + 3]
            const icon = slider.querySelector('.animated')
            animateWithDelay(icon, 'zoomIn', 1500)
          },
        },
      },
      orderOption: {
        grabCursor: true,
        speed: 1000,
        loop: false,
        observer: true,
        observeParents: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
      },
    }
  },
  created() {
    this.getServiceDynamicData(this.cid)
  },
  mounted() {
    this.dataInterval = setInterval(() => {
      this.getServiceDynamicData(this.cid)
    }, this.$interval)
  },
  beforeDestroy() {
    if (this.orderSwiper) {
      this.orderSwiper.destroy()
      this.orderSwiper = null
    }
    if (this.photoSwiper) {
      this.photoSwiper.destroy()
      this.photoSwiper = null
    }
  },
  methods: {
    onDialogOpened() {
      if (!this.photoSwiper) this.photoSwiper = this.$refs.photoSwiper && this.$refs.photoSwiper.swiper
      if (this.photoSwiper) {
        this.photoSwiper.slideTo(0, 0, false)
        if (this.orderData.photos.length === 1) {
          this.photoSwiper.autoplay.stop()
        } else {
          this.photoSwiper.autoplay.start()
        }
      }
    },
    getServiceDynamicData(cid) {
      this.$api
        .getServiceDynamic(cid)
        .then((data) => {
          // console.log(data)
          if (!data || !data.length) return
          this.swiperData = data
        })
        .catch((error) => {
          console.error(error)
        })
    },
    getServiceOrderData(oid) {
      this.$api.getServiceOrder(oid).then((res) => {
        // console.log(res)
        if (!res) return
        const photos =
          res.ServiceOrderPhotos &&
          res.ServiceOrderPhotos.replace(/;$/, '')
            .split(';')
            .map((url) => `${process.env.VUE_APP_BASE_URL}${url}`)
        this.orderData = {
          id: res.ID,
          photos: photos,
          type: res.ItemName,
          time: res.ServiceTime,
          timeEnd: res.EndServiceTime || '-',
          timeStart: res.BeginServiceTime || '-',
          address: res.ServiceAddress || '-',
          addrEnd: res.EndPosition || '-',
          addrStart: res.BeginPosition || '-',
          elderName: res.PersonName,
          elderPhone: res.PersonTel || '-',
          staffName: res.ServiceEmployeeName,
          staffPhone: res.ServiceEmployeeTel || '-',
        }
        this.dialogVisible = true
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.swiper-view {
  .sv-nodata {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }

  .sv-swiper {
    width: 100%;
    height: 100%;
  }

  .sv-swiper-slide {
    display: flex;
    align-items: center;
    padding: 5px 20px;

    + .sv-swiper-slide::before {
      content: '';
      position: absolute;
      top: -0.5px;
      width: 100%;
      height: 1px;
      background: url('../assets/images/bg_line.png') no-repeat center center/60% 100%;
    }

    &__avatar {
      display: inline-flex;
      flex-direction: column;
      align-items: center;
      flex: none;
      width: 50px;
      overflow: hidden;

      > img {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        border: 1px solid #0077fc;
      }

      > div {
        z-index: -1; // 解决IE隐藏失效问题
        width: auto;
        font-size: 12px;
        text-align: center;
        white-space: nowrap;
      }
    }

    &__info {
      flex: auto;
      // width: 350px;
      margin-left: 10px;
    }

    &__done {
      flex: none;
      width: 30px;
      height: 30px;
    }

    &__wrap {
      display: flex;
      align-items: center;
      width: 100%;
      font-size: 12px;
      color: #96d0fc;

      + .sv-swiper-slide__wrap {
        margin-top: 5px;
      }

      img {
        width: 15px;
        height: auto;
        margin-right: 5px;
      }

      span {
        @include text-ellipsis-single;
      }
    }

    &__time {
      display: inline-flex;
      align-items: center;
      span {
        width: 130px;
      }
    }

    &__address {
      display: inline-flex;
      align-items: center;
      span {
        width: 200px;
      }
    }

    &__desc {
      font-size: 14px;
      color: #fff;
      span {
        width: 350px;
      }
    }
  }
}
</style>
